export default "/eye-close.png"